<ion-app>
    <div class="impersonation-banner" *ngIf="isImpersonating" #impersonationBanner>
        <span>{{ 'common_impersonation_banner' | translate: { email: userService.userEMail } }}</span>
        <button class="impersonation-banner__exit" (click)="exitImpersonation()">{{ 'common_impersonation_exit' | translate }}</button>
    </div>
    <ion-router-outlet *ngIf="!isMobile"></ion-router-outlet>
    <div class="mobile-blocker" *ngIf="isMobile">
        <div class="mobile-blocker__bg" aria-hidden="true">
            <div
                class="bg-col"
                *ngFor="let _ of bgCols; let i = index"
                [class.shift]="i % 2 === 1"
            >
                <div class="bg-logo" *ngFor="let __ of bgRows"></div>
            </div>
        </div>
        <div class="mobile-blocker__veil" aria-hidden="true"></div>
        <div class="mobile-blocker__content">
            <div class="mobile-blocker__title">
                {{ "common_mobile_blocker_message" | translate }}
            </div>
        </div>
    </div>
</ion-app>
